<template>
  <iModal
    :show-secondary-action-button="false"
    :max-width="550"
    title="Invite User"
    :primary-action-button-loading="isInviteUserLoading"
    @close="closeModal"
    @click:primary="inviteUserToPublication"
  >
    <InvitePublicationUserForm
      :show-submit-button="false"
      publication-id="publicationId"
    />
  </iModal>
</template>

<script>
import { mapState } from "pinia";
import { useInviteUserStore } from "@/stores/invite-user-store";
import InvitePublicationUserForm from "@/components/publication/InvitePublicationUserForm.vue";

export default {
  name: "InvitePublicationUserModal",
  components: {
    InvitePublicationUserForm,
  },
  props: {
    publicationId: {
      type: Number,
      required: true,
    },
  },
  emits: ["close"],
  computed: {
    ...mapState(useInviteUserStore, [
      "isInviteUserLoading",
    ]),
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    inviteUserToPublication() {
      useInviteUserStore().inviteUser(this.publicationId);
    },
  },
};
</script>
